export default __webpack_public_path__ + "static/media/icon-facebook-white.8797e9ae.svg";